import {
  INIT_SUCCESS_TREE,
  INIT_FAIL_TREE,
  SAVE_SUCCESS_TYPES_PAIEMENTS,
  SAVE_FAIL_TYPES_PAIEMENTS,
  UPDATE_SUCCESS_TYPES_PAIEMENTS,
  UPDATE_FAIL_TYPES_PAIEMENTS,
  DELETE_SUCCESS_TYPES_PAIEMENTS,
  DELETE_FAIL_TYPES_PAIEMENTS,
} from "../actions/treeAction";

const initialState = {
  loaded: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case INIT_SUCCESS_TREE:
      return {
        ...state,
        loaded: true,
        data: action.payload,
        error: null,
      };
    case INIT_FAIL_TREE:
      return {
        ...state,
        loaded: false,
        data: null,
        error: action.error,
      };
    case SAVE_SUCCESS_TYPES_PAIEMENTS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: [...state.data, action.payload],
        error: null,
      };
    case SAVE_FAIL_TYPES_PAIEMENTS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case UPDATE_SUCCESS_TYPES_PAIEMENTS:
      const updatedListe = [];

      state.data.forEach((item) => {
        if (item.type_paiement_id === action.payload.type_paiement_id) {
          item = action.payload;
        }
        updatedListe.push(item);
      });

      return {
        ...state,
        loading: false,
        loaded: true,
        data: updatedListe,
        error: null,
      };
    case UPDATE_FAIL_TYPES_PAIEMENTS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case DELETE_SUCCESS_TYPES_PAIEMENTS:
      const filtered = state.data.filter((item) => {
        return item.type_paiement_id !== action.id;
      });
      return {
        ...state,
        loading: false,
        loaded: true,
        data: filtered,
        error: null,
      };
    case DELETE_FAIL_TYPES_PAIEMENTS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    default:
      return state;
  }
}
